import React from "react"
import types from "prop-types"
import { HiddenSideTabs } from "shared/tabs"
import { useSelector } from "react-redux"
import {
  currentUserIsInAdminRole as getCurrentUserIsInAdminRole,
} from "reduxSlices/sessionSlice"
import { isFeatureEnabled } from "reduxSlices/featuresSlice"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { REPORT_SFTP_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import { ORG_OPTIONS_LISTS } from "utils/featuresHelpers"
import { getInitialActiveIndexFromQueryParams } from "utils/tabHelper"
import FacilityGroupCodesTab, { useFacilityGroupCodesTabHeading } from "./FacilityGroupCodesTab"
import GeneralTab, { GENERAL_TAB_HEADING } from "./GeneralTab"
import QuestionTagsTab, { QUESTION_TAGS_TAB_HEADING } from "./QuestionTagsTab"
import SFTPSettingsTab, { SFTP_SETTINGS_TAB_HEADING } from "./SFTPSettingsTab"
import AnswerOptionsTab, { ANSWER_OPTIONS_TAB_HEADING } from "./AnswerOptionsTab"

const SFTPTab = {
  title: SFTP_SETTINGS_TAB_HEADING,
  TabContent: SFTPSettingsTab,
}

const AnswerOptionsTabObject = {
  title: ANSWER_OPTIONS_TAB_HEADING,
  TabContent: AnswerOptionsTab,
}

const GeneralSettingsTabs = ({ tabProps = {} }) => {
  const currentUserIsInAdminRole = useSelector(getCurrentUserIsInAdminRole)
  const organizationSubscribedToSFTPFeature = useSelector(
    subscribedToAddOnFeature(REPORT_SFTP_FEATURE_NAME),
  )
  const orgOptionsListsFeatureEnabled = useSelector(isFeatureEnabled(ORG_OPTIONS_LISTS))
  const facilityGroupCodesTabHeading = useFacilityGroupCodesTabHeading()

  const showSFTPTab = organizationSubscribedToSFTPFeature && currentUserIsInAdminRole
  const showAnswerOptionsTab = orgOptionsListsFeatureEnabled && currentUserIsInAdminRole

  const allTabs = [
    {
      title: GENERAL_TAB_HEADING,
      TabContent: GeneralTab,
      props: tabProps,
    },
    {
      title: QUESTION_TAGS_TAB_HEADING,
      TabContent: QuestionTagsTab,
      props: tabProps,
    },
    ...(showAnswerOptionsTab ? [AnswerOptionsTabObject] : []),
    {
      title: facilityGroupCodesTabHeading,
      TabContent: FacilityGroupCodesTab,
      props: tabProps,
    },
    ...(showSFTPTab ? [SFTPTab] : []),
  ]

  return (
    <HiddenSideTabs tabs={allTabs} initialActiveIndex={getInitialActiveIndexFromQueryParams(allTabs)} />
  )
}

GeneralSettingsTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object,
}

export default GeneralSettingsTabs
